import { State } from '../../types';

export const mississippi: State = {
  name: 'Mississippi',
  abbreviation: 'MS',
  terms: [
    {
      word: 'Biloxi',
      phonetic: 'bih-LUCK-see',
      // audioUrl: '/audio/biloxi.mp3',
      description: 'A city on the Gulf Coast, often mispronounced as "bi-LOCK-see."'
    },
    {
      word: 'Gautier',
      phonetic: 'GO-shay',
      // audioUrl: '/audio/gautier.mp3',
      description: 'A city in Jackson County, commonly mispronounced due to its French origin.'
    },
    {
      word: 'Natchez',
      phonetic: 'NATCH-iz',
      audioUrl: '/audio/natchez.mp3',
      description: 'Historic city on the Mississippi River'
    },
    {
      word: 'Pass Christian',
      phonetic: 'pass kris-CHEN',
      // audioUrl: '/audio/pass_christian.mp3',
      description: 'A city on the Gulf Coast, often mispronounced as "pass christian."'
    },
    {
      word: 'Saucier',
      phonetic: 'SOH-shur',
      // audioUrl: '/audio/saucier.mp3',
      description: 'An unincorporated community in Harrison County, often mispronounced due to its French origin.'
    },
    {
      word: 'Tchoutacabouffa River',
      phonetic: 'choo-tah-kah-BUH-fuh',
      // audioUrl: '/audio/tchoutacabouffa_river.mp3',
      description: 'A river in southern Mississippi with a challenging name of Native American origin.'
    },
    {
      word: 'Toomsuba',
      phonetic: 'toom-SOO-bah',
      // audioUrl: '/audio/toomsuba.mp3',
      description: 'An unincorporated community in Lauderdale County, often mispronounced due to its unique spelling.'
    },
    {
      word: 'Yalobusha',
      phonetic: 'yah-loh-BUSH-uh',
      // audioUrl: '/audio/yalobusha.mp3',
      description: 'A county in Mississippi, often mispronounced due to its Native American origin.'
    }
  ]
};